import {useRef, useState} from "react";

export const useRessourceState = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | undefined>();

    return {
        isLoading,
        setIsLoading,
        error,
        setError,
    }
}
